namespace Matrix.Data {
    export class CurrencyColumns {
        static columnsKey = 'Data.Currency';
    }
}
